import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type FinancialOrderInformationForCustomerProjectionId = Branded<
    string,
    "FinancialOrderInformationForCustomerProjectionId"
>;
const financialOrderInformationForCustomerProjectionIdPrefix =
    "order_history_for_customer_projection__";
const {
    factory: financialOrderInformationForCustomerProjectionIdFactory,
    assert: isFinancialOrderInformationForCustomerProjectionId,
    zodSchema: financialOrderInformationForCustomerProjectionIdZodSchema,
} = genericId<FinancialOrderInformationForCustomerProjectionId>(
    financialOrderInformationForCustomerProjectionIdPrefix,
);

export {
    financialOrderInformationForCustomerProjectionIdFactory,
    financialOrderInformationForCustomerProjectionIdPrefix,
    financialOrderInformationForCustomerProjectionIdZodSchema,
    isFinancialOrderInformationForCustomerProjectionId,
};
export type { FinancialOrderInformationForCustomerProjectionId };
